'use client';

import React from 'react';
import Link from 'next/link';

const professions = [
  { id: 'prof-student', label: 'Students', emoji: '🎓', count: '320+ activities' },
  { id: 'prof-dev', label: 'Developers', emoji: '💻', count: '185+ activities' },
  { id: 'prof-designer', label: 'Designers', emoji: '🎨', count: '120+ activities' },
  { id: 'prof-doctor', label: 'Doctors', emoji: '🏥', count: '65+ activities' },
  { id: 'prof-teacher', label: 'Teachers', emoji: '📚', count: '140+ activities' },
  { id: 'prof-marketer', label: 'Marketers', emoji: '📊', count: '98+ activities' },
  { id: 'prof-writer', label: 'Writers', emoji: '✍️', count: '87+ activities' },
  { id: 'prof-engineer', label: 'Engineers', emoji: '⚙️', count: '110+ activities' },
  { id: 'prof-finance', label: 'Finance', emoji: '💹', count: '75+ activities' },
  { id: 'prof-entrepreneur', label: 'Entrepreneurs', emoji: '🚀', count: '93+ activities' },
  { id: 'prof-artist', label: 'Artists', emoji: '🖼️', count: '78+ activities' },
  { id: 'prof-data', label: 'Data Analysts', emoji: '📈', count: '82+ activities' },
];

export default function ProfessionSection() {
  return (
    <section id="professions" className="landing-section">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-xs font-semibold uppercase tracking-widest mb-3 block" style={{ color: '#06B6D4' }}>For Everyone</span>
          <h2 className="font-extrabold mb-4" style={{ fontSize: 'clamp(24px, 3.5vw, 42px)', letterSpacing: '-0.02em' }}>
            Competitions Built for <span className="text-gradient-primary">Your Profession</span>
          </h2>
          <p className="text-lg max-w-2xl mx-auto" style={{ color: 'var(--muted-foreground)' }}>
            Whether you're a student, developer, doctor, or entrepreneur — Brain Basket has challenges designed specifically for your skills.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 xl:grid-cols-6 2xl:grid-cols-6 gap-3">
          {professions.map((prof) => (
            <Link href="/discover-screen" key={prof.id}
              className="flex flex-col items-center text-center p-4 rounded-xl cursor-pointer transition-all hover:scale-105"
              style={{
                background: 'rgba(17, 24, 39, 0.8)',
                border: '1px solid var(--border)',
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLElement).style.borderColor = 'rgba(124, 58, 237, 0.4)';
                (e.currentTarget as HTMLElement).style.background = 'rgba(124, 58, 237, 0.08)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLElement).style.borderColor = 'var(--border)';
                (e.currentTarget as HTMLElement).style.background = 'rgba(17, 24, 39, 0.8)';
              }}
            >
              <span style={{ fontSize: '32px' }} className="mb-2">{prof.emoji}</span>
              <p className="text-sm font-semibold text-foreground">{prof.label}</p>
              <p className="text-xs mt-1" style={{ color: 'var(--muted-foreground)' }}>{prof.count}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}